import React, { memo } from 'react';

import Symbol from '@/components/atomic/atoms/data-display/icons/symbol';
import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const IconSliceComponent: React.FC<BasicComponentProps> = ({
	$exposerSuffix,
}) => (
	<Symbol
		$exposerSuffix={$exposerSuffix}
		id={IconNames.CHEVRON_RIGHT}
		viewBox={[0, 0, 16, 16]}
		dangerouslySetInnerHTML={{
			__html: '<path d="M11.687 6.528L4.785.176a.666.666 0 0 0-.903.982l6.903 6.352a.665.665 0 0 1 0 .981l-6.903 6.352a.667.667 0 0 0 .902.981l6.902-6.352c.397-.366.646-.89.646-1.472s-.248-1.106-.645-1.472z"></path>',
		}}
	/>
);

const IconSlice = memo(
	withExposer(IconSliceComponent, 'iconSlice_CHEVRON_RIGHT'),
);

export default IconSlice;
